import React, { useRef, useState, useContext } from 'react';
import { AppContext } from '../App';
import { getTorneiInEvidenza } from '../data/utils/getTorneiInEvidenza';
import { getConfiguration } from '../data/utils/configuration';
import { loadLanguage } from '../data/utils/loadLanguage';
import { getSimpleKeyboardLayout } from '../data/utils/getSimpleKeyboardLayout';
import { labels } from '../data/labels';
import { PrematchContext } from '../prematch/Prematch';
import SearchOverlay from '../prematch/search/SearchOverlay';
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

function TopMenuSelector(props) {
    const conf = getConfiguration();
    const appContext = React.useContext(AppContext);
    const prematchContext = useContext(PrematchContext);
    const [showSearch, setShowSearch] = useState(false);
    const [search, setSearch] = useState('');
    const usageMode = window.appConfig.usageMode;
    const keyboardEnabled = usageMode && usageMode.indexOf('touch') >= 0;
    // if the virtual keyboard is enabled, then I show it when the Search has been enabled
    const [virtualKeyboardShown, setVirtualKeyboardShown] = useState(false);
    const [virtualKeyboardLayout, setVirtualKeyboardLayout] = useState('default');
    
    
    function showVirtualKeyboard(){
    	setVirtualKeyboardShown(true && keyboardEnabled);
    }
    function hideVirtualKeyboard(){
    	setVirtualKeyboardShown(false);
    }
    
    
    function toggleVirtualShift(){
    	const newLayout = virtualKeyboardLayout === 'default' ? 'shift' : 'default';
    	setVirtualKeyboardLayout(newLayout);
    }

    function onKeyPressedVirtualKeyboard(key){
    	(key === '{shift}' || key === '{lock}') && toggleVirtualShift();
    }
    
    function handleClick(){
        let highlights = getTorneiInEvidenza(props.data.sport).sportsList;
        const tournamentsHighlights = [];
        prematchContext.applyTemporalFilter(highlights).forEach(sport => {
            prematchContext.applyTemporalFilter(sport.competitions).forEach(tournament => {
                tournamentsHighlights.push(tournament);
            });
        });
        prematchContext.openTopMatchMenu(tournamentsHighlights);
    }

    function toggleSearch() { 
        if (showSearch) {
            setSearch('');
            setShowSearch(false);
            hideVirtualKeyboard();
        }
        else{
        	setShowSearch(true);
        	showVirtualKeyboard();
        }
    }

    const input = useRef(null);
    const keyboardRef = useRef(null);
    const outcomesUrl = conf.ps?.rst.replace('{{lang}}', loadLanguage().toLowerCase()) ?? '';
    const statsUrl = conf.ps?.stg.replace('{{lang}}', loadLanguage().toLowerCase()) ?? '';
   
    function handleChange(event) {
        setSearch(event.target.value);
        if(keyboardRef.current){
        	keyboardRef.current.setInput(event.target.value);        	
        }
    }
    function handleChangeVirtualKeyboard(value){
    	if(value.indexOf('Clear.') >= 0){
    		handleReset();
    	}
    	else{
        	setSearch(value);
        	input.current.value = value;
    	}
    }

    function handleReset() {
        input.current.value = '';
        input.current.focus();
        setSearch('');
        if(keyboardRef.current){
        	keyboardRef.current.setInput('');        	
        }
    }

    function toggleCheckTicket(){
        console.log("qrButton button clicked")
        appContext.toggleCheckTicketPopup(true);
    }
    
    return <>
        <nav className={`nav-buttons-container ${showSearch?'nav-buttons-container--searchBarOpen':''}`}>
            {showSearch ?
                <>
                    <div className="top-menu-buttons-container">
                        <div className="input-container">
                            <input ref={input} id="input-search-events" type="text" autoComplete="off" placeholder={labels['general.search']} spellCheck="false" onChange={handleChange} autoFocus />
                            <div className="arrow-container">
                                <i className="fa fa-backspace" onClick={handleReset}></i>
                            </div>
                            {search.length > 2 &&
                                <SearchOverlay search={search} toggleSearch={toggleSearch} />
                            }
                        </div>
                    </div>
                    <div className="topMenuElement search-button" onClick={toggleSearch}>
                        <i className="fa fa-times"></i>
                    </div>
                    {conf.mse && 
                        <div className="qrButton" onClick={toggleCheckTicket} ></div>
                    }
                </>
                :
                <>
                    <div className="top-menu-buttons-container">
                        <div className="top-menu-buttons-slider">
                            {Object.keys(prematchContext.favoriteTournaments).length > 0 &&
                                <div id="nav-favorite-tournaments" className="nav-slider-item-container topMenuElement" onClick={() => prematchContext.openFavoriteTournaments()}>
                                    <div className="sport-img-container">
                                        <div className="sport-img icoTopLeague"></div>
                                    </div>
                                    <div className="nav-slider-item">{labels['navbar_buttons.favorite_tournaments']}</div>
                                </div>
                            }
                            {!window.appConfig.SHOP_MODE &&
                            	<>
                                   <div id="nav-top-league" className="nav-slider-item-container topMenuElement" onClick={handleClick}>
                                        <div className="sport-img-container">
                                            <div className="sport-img icoTopLeague"></div>
                                        </div>
                                        <div className="nav-slider-item">{labels['navbar_buttons.top_leagues']}</div>
                                    </div>
                                    {conf.foc?.enb &&
                                        <div id="nav-favorite-odds" className="nav-slider-item-container topMenuElement" onClick={() => prematchContext.openFavoriteOdds()}>
                                            <div className="sport-img-container">
                                                <i className="sport-img fa fa-star"></i>
                                            </div>
                                            <div className="nav-slider-item">{labels['favorite_odds']}</div>
                                        </div>
                                    }
                                    <div id="nav-top-betting" className="nav-slider-item-container topMenuElement" onClick={() => prematchContext.openTopMatch()}>
                                        <div className="sport-img-container">
                                            <div className="sport-img icoTopMatch"></div>
                                        </div>
                                        <div className="nav-slider-item">{labels['navbar_buttons.top_matches']}</div>
                                    </div>
                                    <div id="nav-last-minute" className="nav-slider-item-container topMenuElement" onClick={() => prematchContext.openLastMinute()}>
                                        <div className="sport-img-container">
                                            <div className="sport-img icoLastMinute"></div>
                                        </div>
                                        <div className="nav-slider-item">{labels['navbar_buttons.last_minute']}</div>
                                    </div>
                                    <div id="nav-statistiche" className="nav-slider-item-container topMenuElement" onClick={() => prematchContext.openStatistics(statsUrl)}>
                                        <div className="sport-img-container">
                                            <div className="sport-img icoStatistiche"></div>
                                        </div>
                                        <div className="nav-slider-item">{labels['navbar_buttons.stats']}</div>
                                    </div>
                                    <div id="nav-risultati" className="nav-slider-item-container topMenuElement" onClick={() => prematchContext.openStatistics(outcomesUrl)}>
                                        <div className="sport-img-container">
                                            <div className="sport-img icoRisultati"></div>
                                        </div>
                                        <div className="nav-slider-item">{labels['navbar_buttons.scores']}</div>
                                    </div>
                                  </>
                            }
                            <div className="padding"></div>
                        </div>
                    </div>
                    <div className="topMenuElement search-button" onClick={toggleSearch}>
                        <i className="fa fa-search"></i>
                    </div>
                    {conf.mse && 
                        <div className="qrButton" onClick={toggleCheckTicket} ></div>
                    }
                </>
            }
       </nav>
       
       {
   		   virtualKeyboardShown && 
   		   <div className="virtual-keyboard-container">
   		   		<Keyboard onKeyPress={onKeyPressedVirtualKeyboard}
                          keyboardRef={r => (keyboardRef.current = r)} 
                          layout={getSimpleKeyboardLayout()} 
                          layoutName={virtualKeyboardLayout} 
                          onChange={handleChangeVirtualKeyboard} />
   		   </div>
       }
    </>


}


export default TopMenuSelector;